import { Box } from "@mui/material";
import React, { FC } from "react";
import { RollinSmallLogo } from "shared/theme/logo/RollinSmallLogo";
import { StyledAvatarContainer } from "./styled";

const SupportAvatar: FC = () => {
  return (
    <Box display="flex" columnGap="0.75rem">
      <StyledAvatarContainer>
        <RollinSmallLogo width={18} height={26} id="support" />
      </StyledAvatarContainer>
    </Box>
  );
};

export default SupportAvatar;
